/**
 * Copyright (c) 2019 ООО Код Ускорения Бизнеса - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

import _ from 'lodash';
import CaptchaCollection from '@/classes/CaptchaCollection';

// initial state
const state = {
  captcha: null,
  error: null,
};

// getters
const getters = {
  captchaId(state) {
    return _.get(state.captcha, 'id', null);
  },
  captchaImg(state) {
    return _.get(state.captcha, 'data', null);
  },
  error(state) {
    return state.error;
  },
};

// actions
const actions = {
  ...CaptchaCollection.actions,

  async fetch({ commit, dispatch }) {
    try {
      const captcha = await dispatch('getCaptcha', { __native: true });
      commit('setCaptcha', _.get(captcha, 'data.result', {}));
    } catch (error) {
      commit('setError', 'Something went wrong, please try again later!');
    }
  },
  async check({ commit, dispatch, state }, text) {
    try {
      const verifyResult = await dispatch('verify', {
        id: state.captcha.id,
        text,
      });

      if (verifyResult && !_.get(verifyResult, 'data.result.success')) {
        commit('setCaptcha', _.get(verifyResult, 'data.result.newCaptcha', null));
        commit('setError', _.get(verifyResult, 'data.result.message', null));
      } else {
        commit('setError', null);
      }
    } catch (error) {
      commit('setError', 'Something went wrong, please try again later!');
      dispatch('fetch');
    }
  },
};

// mutations
const mutations = {
  setCaptcha(state, captcha) {
    state.captcha = captcha;
  },
  setError(state, text) {
    state.error = text;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
